import React, { PropTypes, Component } from 'react';
import { Link, IndexLink } from 'react-router';

import Header from './Header';
import Footer from './Footer';

class Layout extends Component {
    render () {
        return (
            <div>
              <Header />
              {this.props.children}
              <Footer />
            </div>
        );
    }
}

Layout.propTypes = {
    children: PropTypes.element
};

export default Layout;



/** WEBPACK FOOTER **
 ** ./src/components/Layout.js
 **/